import React, { useEffect, useState } from 'react';
import { intervalToDuration } from 'date-fns';

const AlertCountdown = ({ targetTime, classNames = '', onCountdownFinished = () => {} }) => {
    const [displayed, setDisplayed] = useState(true);
    const [timeLeft, setTimeLeft] = useState(null);
    const [timeUp, setTimeUp] = useState(false);

    useEffect(() => {
        const updateCountdown = () => {
            const now = new Date();
            const difference = intervalToDuration({ start: now, end: targetTime });

            if (difference.seconds <= 0) {
                setTimeLeft(0);
                setTimeUp(true);
                clearInterval(intervalId);
            } else {
                const hours = difference.hours ?? 0;
                const minutes = difference.minutes ?? 0;
                const seconds = difference.seconds ?? 0;

                // let suffix;
                //
                // if (hours >= 1) {
                //     // Show hours + minutes (both two digits)
                //     suffix = `${String(hours).padStart(2, "0")} ${hours > 1 ? 'heures' : 'heure'} et ${String(minutes).padStart(2, "0")} ${minutes > 1 ? 'minutes' : 'minute'}`;
                // } else {
                //     // Show minutes + seconds (both two digits)
                //     suffix = `${String(minutes).padStart(2, "0")} ${minutes > 1 ? 'minutes' : 'minute'} ${String(seconds).padStart(2, "0")} ${seconds > 1 ? 'secondes' : 'seconde'}`;
                // }

                // Always show hh:mm:ss with leading zeros
                let suffix = `${String(hours).padStart(2, "0")}h ${String(minutes).padStart(2, "0")}m ${String(seconds).padStart(2, "0")}s`;
                if (hours === 0) {
                    suffix = `${String(minutes).padStart(2, "0")}m ${String(seconds).padStart(2, "0")}s`;
                }

                setTimeLeft(suffix);
            }
        };

        // Update the countdown every second
        const intervalId = setInterval(updateCountdown, 1000);
        updateCountdown(); // Run immediately

        return () => clearInterval(intervalId); // Cleanup interval on unmount
    }, [targetTime]);

    useEffect(() => {
        if (timeUp) {
            setTimeout(() => {
                setDisplayed(false);
                onCountdownFinished();
            }, 5000);
        }

    }, [timeUp]);

    return (
        <>
            {displayed && (
                <div className={`${classNames}`}>
                    {/*{!timeUp && (*/}
                    {/*    <svg className="min-w-4 size-5 sm:size-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">*/}
                    {/*        <rect width="256" height="256" fill="none"/>*/}
                    {/*        <path d="M224,136c-4.07,49.28-45.67,88-96,88a96,96,0,0,1-96-96c0-50.33,38.72-91.93,88-96" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"/>*/}
                    {/*        <polyline points="128 72 128 128 184 128" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"/>*/}
                    {/*        <circle fill="currentColor" cx="160" cy="36" r="12"/>*/}
                    {/*        <circle fill="currentColor" cx="196" cy="60" r="12"/>*/}
                    {/*        <circle fill="currentColor" cx="220" cy="96" r="12"/>*/}
                    {/*    </svg>*/}
                    {/*)}*/}
                    {/*{timeUp && (*/}
                    {/*    <svg className="min-w-4 size-5 sm:size-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">*/}
                    {/*        <rect width="256" height="256" fill="none"/>*/}
                    {/*        <line x1="160" y1="96" x2="96" y2="160" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"/>*/}
                    {/*        <line x1="96" y1="96" x2="160" y2="160" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"/>*/}
                    {/*        <circle cx="128" cy="128" r="96" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"/>*/}
                    {/*    </svg>*/}
                    {/*)}*/}
                    <span>
                        {!timeUp && timeLeft}
                    </span>
                </div>
            )}
        </>
    );
};

export default AlertCountdown;
